import React from "react";
import { Tooltip } from "react-tooltip";
import { FavoritesIcon } from "../../assets/images/svg";
import "./PageHeader.scss";

const PageHeader = ({
  pageTitle = "",
  learnMore,
  isFavorite,
  isFavoriteLoading,
  toggleFavorite,
  withFavorite
}) => {
  const handleClick = (e) => {
    e.preventDefault();
    if (!isFavoriteLoading) toggleFavorite(!isFavorite);
  };

  let id = pageTitle.toLowerCase() + "-tooltip";

  return (
    <div className="page-header-nav">
      <p className="page-header-nav__title">{pageTitle}</p>

      {learnMore && <div className="page-header-nav__learnMore">{learnMore}</div>}
      {withFavorite && (
        <button
          onClick={handleClick}
          data-tooltip-id={id}
          className={`page-header-nav__favorites 
           ${isFavorite ? "page-header-nav__favorites--selected" : ""}
           ${isFavoriteLoading ? "page-header-nav__favorites--disabled" : ""}`}
        >
          <FavoritesIcon width="20" height="20" viewBox="0 0 18 18" className="icon" />
          <Tooltip
            id={id}
            place="bottom"
            textColor="white"
            className="tooltip"
            content={() =>
              isFavoriteLoading ? "" : isFavorite ? "Remove from Favorites" : "Add to Favorites"
            }
          />
        </button>
      )}
    </div>
  );
};

export default PageHeader;
